import request from "../utils/request";

export function getBossData() {
  return request({
    url: "/index/get_YL_Table_ByShop_list",
    method: "post",
  });
}
